import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewReviewButtonContainer } from '../NewReviewButton';
import { NoReviews } from '../../components/NoReviews';
import { getNewbuildingInfo } from '../../selectors/newbuildingInfo';
import { NewQuestionButtonContainer } from '../NewQuestionButton/NewQuestionButtonContainer';

export function NoReviewsContainer(): React.JSX.Element {
  const { newbuildingName } = useSelector(getNewbuildingInfo);

  return (
    <NoReviews
      newbuildingName={newbuildingName}
      newReviewButton={<NewReviewButtonContainer size="XS" fullWidth={false} />}
      newQuestionButton={<NewQuestionButtonContainer size="XS" fill="fill_secondary" fullWidth={false} />}
    />
  );
}
